<template>
  <div class="pmHomeModular">
    <navBarNoLab :onIndex="0"></navBarNoLab>
    <div class="pmContent">
      <!-- banner-start -->
      <div id="scrollTg1" class="banner">
        <div class="video">
            <video class="javaVideo" style="width: 100%;" autoplay loop muted>
                <source
                class="javaSource"
                src="./images/pm_banner.mp4"
                type="video/mp4"
                />
            </video>
        </div>    
        <span data-v-c9a2850a="" class="bannerfont">
          <img data-v-c9a2850a="" src="./pmImg/pm_banner_font.png" width="1007px" alt="">
        </span>
      </div>
      <!-- banner-end -->
      <!-- 项目列表-start -->
      <div id="scrollTg2" class="screen objectList">
        <div class="centent" v-if="objectListdata && objectListdata.length > 0">
          <HomeTitle :title="`真实项目呈献，助你进阶中级产品经理`" subTitle='项目资料真实完备，让你便于理解并达到中级产品经理标准要求'></HomeTitle>
          <div class="cont">
            <div class="objectItems">
                  <div class="itemList" v-for="(item, ind) in objectList"  :key="'it'+ind" @click="goDetails(item)">
                      <div class="showImg">
                        <img :src="item.image[0].url" width="100%" alt="">
                        <div class="but"><span>立即查看</span></div>
                      </div>
                      <div class="infoCont">
                        <div class="tit" v-if="item.lableList">
                          {{item.title}}
                          <span v-for="(it, i) in item.lableList.split('、')" :key="i">{{it}}</span>
                        </div>
                        <div class="des">{{ item.desc }}</div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
      <!-- 项目列表-end -->
      <!-- 项目优势-start -->
        <div>
          <HomeTitle :title="`众多项目紧跟市场节奏，合理且体系完备`" subTitle='丰富的项目类型，让你汲取更多经验，择业范围更广'></HomeTitle>
          <projectAdvantage />
        </div>
      </div>
      <!-- 项目优势-end -->
      <bottomWidge></bottomWidge>
  </div>
</template>

<script>
import navBarNoLab from "./../../../components/navBarNoLab";
import bottomWidge from "./../../../components/bottomWidge";
import { JavaHome } from "../../../../gqlapi/JavaHome.js";
import HomeTitle from './components/HomeTitle';
import { CutString } from './../../../../utils/tools'
import projectAdvantage from "./components/projectAdvantage"
export default {
  name: "uiHome",
  components: {
    navBarNoLab,
    bottomWidge,
    HomeTitle,
    projectAdvantage
  },
  data() {
    return {
      stSrcollNum:0,
      dialogVisible: false,
      bannerInfo:{},
      rollItemIndex:0,
      showDescInd: '',
      swiperUiOption: {
        slidesPerView: 1,
        spaceBetween: 20,
        autoplay:false,
        loop: false,
        loopFillGroupWithBlank: true,
        delay: 3000,
        pagination: {
          el: ".swiper-ui-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-ui-button-next",
          prevEl: ".swiper-ui-button-prev",
          disabledClass: "swiper-ui-disabled-class",
        },
      },
      swiperUiScrollOption: {
        // mousewheel: true,
        effect: "fade",
        pagination: {
          el: ".swiper-ui-scroll-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-ui-scroll-button-next",
          prevEl: ".swiper-ui-scroll-button-prev",
          disabledClass: "swiper-ui-scroll-disabled-class",
        },
      },
      floatPositTop: 0,
      objectListdata:null,
      objectIndex:0,
      openTag: 0,
      overTag: 0,
      fifthScreen: null,
      sixthScreen: {},
      eighthScreen: null,
      ninthScreen: null,
      bigImageInfo: '',
      itemData: [],
      lodTag2: false,
      lodTag5: false,
      numberA: 24,
      numberB: 5,
      numberC: 5,
      timerNum: {numberA:null, numberB:null, numberC:null,},
      baseInfo:{
        baseInfoTitle1: '',
        baseInfoTitle2: '',
        baseInfoDesc1: '',
        baseInfoDesc2: '',
        pVideoUrl: '',
        videoLogoImage: ''
      },
      contTop: 2500,
      floatTag: 0,
      scrollLeft: 0,
      botTop:0,
      typeList:['全部项目', 'UI/UE', '品牌/平面', '电商/运营', 'C4D/三维'],
      studentTypeList:[ '作品集', 'UI/UE', '品牌/平面','电商/运营', '手绘/插画', 'C4D/三维'],
      objAct:0,
      stAct:0,
      objectList:[],
      contrastData:{
        leftCont:[
          {title:'项目课程适用不同企业发展阶段', desc:'课程「从0到1」的新项目只占20%，「从1到2」的升级项目占比80%，各种项目全覆盖，轻松面对工作中各种阶段企业的各种项目。', icon: '', label:'研发'},
          {title:'独一无二的设计作品，让你面试脱颖而出', desc:'你的作品不在局限于教学项目，而是根据不用业务场景，举一反三，获得拥有强烈的个人风格的作品集，告别雷同，打开就业的第一道大门。', icon: '', label:'业务'},
          {title:'实战项目流程完整，类型广泛', desc:'“需求讨论—产品原型—产品设计…项目迭代”，学员作为设计师角色独立完成项目开发全流程内容，提前进入工作状态，积累项目经验。', icon: '', label:'技术'},
          {title:'仅对主要软件讲解，把课程时间留给精华内容', desc:'仅对主要软件讲解，其他20门同类型软件课程全部免费赠送,多的不只是数量，而是给予你更高含金量的课程。', icon: '', label:'实战'},
        ],
        rightCont:[
          {title:'只做基础项目案例讲解', desc:'「从0到1」已经不符合主流工作场景，但是市面上90%的培训机构还在教授基础项目，学员工作后不知如何对现有项目迭代升级。'},
          {title:'千篇一律的作品集，审美疲劳', desc:'对于讲授项目页面复制粘贴，不关注真实的业务场景，学员作品查重率达到99%，最终淹没在面试的海洋中。'},
          {title:'Demo 级小项目，只有部分页面', desc:'只讲纯设计部分，不涉及项目其他阶段，不会需求分析，不懂产品定位...造成设计作品缺乏全局化思维及逻辑支撑。'},
          {title:'还拿小众软件当付费课程，浪费课堂时间', desc:'同类型软件、辅助软件不分主次统统都讲，仅软件教学就占了60%的课程时间，对重要知识内容只是浅尝辄止。'}]
      },
      processDate:[
        {tit: '项目需求 分析',item: ['项目需求PRD','竞品分析','头脑风暴','创意设计']},
        {tit: '交互原型 设计',item: ['功能模块分析','业务逻辑分析','线框图设计','交互原型设计']},
        {tit: '产品视觉 设计',item: ['视觉KV','启动图标设计','引导页设计','PC界面设计','移动端设计','其他终端设计','数据可视化']},
        {tit: '视觉规范 制定',item: ['尺寸规范','色彩规范','文字规范','使用规范','动效设计']},
        {tit: '视觉运营 设计',item: ['H5页面设计','广告图设计','物料设计','专题页设计']},
        {tit: '产品上线 与迭代',item: ['高保真交互','切图标注','项目上线','迭代升级']}
      ],
      sixscrollData:[
        {
          info:{
            name: '个性化作品，敲开企业大门的关键',
            list: ['教会你的不只是技术，更是变通的设计思路、精进的设计方法、终身受益的经验技巧', '让你的作品不再是对教学项目机械复刻，而是注入个人灵魂风格的个性化作品', '打造你的专属作品集，成功敲开企业大门']
          },
          bigImage: require('./pmImg/img_six_cont1.png')
        },
        {
          info:{
            name: '详细的需求分析',
            list: ['对设计全流程中的每个节点进行拆解分析，让复杂的事情更简单清晰','学员可以像老师一样庖丁解牛般解决复杂的设计需求']
          },
          bigImage: require('./pmImg/img_six_cont2.png')
        },
        {
          info:{
            name: '丰富的解决方案',
            list: ['结合工作场景里的高频问题，让你设计不必从零开始','方案拿来即用，让你成为团队里问题解决最高效的人']
          },
          bigImage: require('./pmImg/img_six_cont3.png')
        }
      ],
      studentListdata: [],
      studentList:[],
      studentList2:[],
      showTagA: false,
      showTagB: false,
      showTagC: false,
      showTagD: false,
      showTagE: false,
      showTagE1: false,
      showTagE2: false,
      showTagF: false,
      showTagF1: false,
      showTagF2: false,
      showTagG: false,
      BigImgUrl:'',
    }
  },
  created() {
    this.getJavaHomeDataes();
  },
  mounted() {
    // window.addEventListener("scroll", this.scrollHandle);
  },
  methods: {
    // 初始化数据获取
    getJavaHomeDataes(){
        this.$axios.post('/api',{
            operationName: "JavaHome",
            variables:{
                id: 7
            },
            query: JavaHome
        }).then((res) => {
          const data = res.data.data.javaHome;
          this.bannerInfo = data.FirstScreen
          this.ninthScreen = data.eighthScreen
          this.objectListdata = data.objectLists2.filter(it => {if(it.isShow){
            // this.typeListInit(it.labelA, 'a')
            // it.LableB && this.typeListInit(it.LableB, 'b')
            return it
            }})
          this.objectList = this.objectListdata
          this.studentListdata = data.studentWorks
          this.studentList = data.studentWorks
          this.studentList2 = data.studentWorks.slice(data.studentWorks.length/2, data.studentWorks.length)
          this.fliterObjListHandle('作品集', 0, 'st')
        })
        .catch((res) => {
          console.log('JavaHome 请求出错：' + res)
        });
    },
    // 项目分类列表动态处理
    typeListInit(lab, type){
      if (!this.typeList.some(n => lab === n)){
        type == 'b' ? this.typeList.push(lab) : this.typeList.unshift(lab)
      }
    },
    swiperDataSet(data){
      let array = []
      if(data.length <= 8){
          array.push(data)
      } else {
        let arrGroup = []
        let num = 1
        data.forEach((n, ind) => {
          arrGroup.push(n)
          if (num == 8 || data.length == ind+1){
            array.push(arrGroup)
          }
          if (num<8){
            num++ 
          } else if (num == 8){
            num=1
            arrGroup = []
          }
        })
      }
      return array
    },
    // 项目分类切换
    fliterObjListHandle(type, ind, st){
      if (st === 'obj'){
        this.objAct = ind
        if (type == '全部项目'){
          this.objectList = this.objectListdata
        } else {
          this.objectList = this.objectListdata.filter(n => n.labelA == type || n.LableB == type ? n : null)
        }
      } else {
        this.stAct = ind
        const basedata = this.studentListdata.filter(n => n.labelA == type ? n : null)
        this.studentList = basedata.slice(0,basedata.length/2)
        this.studentList2 = basedata.slice(basedata.length/2,basedata.length)
      }
    },
    cutstr(str, ind){
      return CutString(str, ind)
    },
    // 打开新页面或者弹窗
    openFileHandle(url){
      if (url){
        window.open(url, "_blank");
      } else {
        this.dialogVisible = true
      }
    },
    // bannber 数字跳转
    dataCount(obj, num, end, time , ind){
      const i = ind ? ind : 1
      this.timerNum[obj] = setInterval(() => {
        if (num < end){
          num += i
        } else if (num == end) {
          clearInterval(this.timerNum[obj])
        }
        this[obj] = num
      }, time)
    },
    // 打开大图
    openBigImg(item){
      if(item.icon && item.icon.length > 0){
        this.BigImgUrl = item.icon[0].url
        setTimeout(() => {
          this.dialogVisible = true
        },200)
      }
    },
    // 点击跳转到项目详情 
    goDetails(item) {
      if(item.url == null ){
        return false
      }
      window.open(item.url, "_blank");
    },
    openNewUrl(url){
      window.open(url, "_blank");
    },
    // 滚动浮窗
    scrollHandle(){
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft;
        this.floatPositTop = scrollTop
        let aimsId1 = document.querySelector('#scrollTg1');
        let aimsId2 = document.querySelector('#scrollTg2');
        let aimsId3 = document.querySelector('#scrollTg3');
        let baseTag = 100
        this.contTop = baseTag;
        this.scrollLeft = scrollLeft
        if( scrollTop >= baseTag && scrollTop <= aimsId1.offsetTop + baseTag){
          this.showTagA = true
        } else if (scrollTop >= aimsId1.offsetTop + baseTag && scrollTop < aimsId2.offsetTop + baseTag){
          this.showTagB = true
        } else if (scrollTop >= aimsId2.offsetTop + baseTag && scrollTop < aimsId3.offsetTop + baseTag){
          this.showTagC = true
        } else if (scrollTop >= aimsId3.offsetTop + baseTag){
          this.showTagD = true
        }
    },
    showStandardHandl(ind){
      this.overTag = ind
    },
    colseStandardHandl(){
      this.overTag = this.openTag
    },
  
    handleVideo(url,e) {
      // 由于切换图层原因，传参url为之后一个 所以不可用 将url放到了切换事件中进行更换
      this.baseInfo.pVideoUrl = url
      window.event ? (window.event.cancelBubble = true) : e.stopPropagation();
      this.$refs.editMenu.dialogFormV(this.baseInfo);
    },
    handleVideoListFirst(url,e) {
      console.log(url)
      this.baseInfo.pVideoUrl = url
      window.event ? (window.event.cancelBubble = true) : e.stopPropagation();
      this.$refs.editMenu.dialogFormV(this.baseInfo);
    },
    handleVideoList(item,e) {
      window.event ? (window.event.cancelBubble = true) : e.stopPropagation();
      this.$refs.editMenuList.dialogFormV(item);
    },
  },
};
</script>

<style src='./style.scss' rel="stylesheet/scss" lang="scss" scoped> </style>
<style lang="scss">
 .el-popover{
    line-height: 22px;
    color: #616a72;
  }
.pmHomeModular .el-dialog{
  padding:0px;
  margin-top: 120px !important;
  background: transparent;
  .close_ico{
      background: #fff;
      position: fixed;
      right: 50px;
      top: 50px;
      width: 30px;
      height: 30px;
      border-radius: 30px;
      border:solid 1px rgba(0,0,0,0.5);
    }
  img{
    display: block;
  }
}
.pmHomeModular .swiper-pagination-bullet{
  margin: 0 4px;
}
.pmHomeModular .el-dialog__header{
  display: none;
}
.uiSwiper, .uiScrollSwiper{
  display: flex;
  justify-content: center;
  align-items: center;
  .swiper-ui-pagination, .swiper-ui-scroll-pagination{ 
    margin: 0 20px;
    .swiper-pagination-bullet{
      background: #636a70 !important;
      width: 12px;
      height: 12px;
    }
    .swiper-pagination-bullet-active{
      background: #FF3366 !important;
    }
  }
  .swiper-ui-button-next, .swiper-ui-scroll-button-next{
    position: relative;
    cursor: pointer;
    width: 31px;
    height: 31px;
    border-radius: 31px;
    background: #FFFFFF;
    box-shadow: 0 0 8px 0 rgba(22,37,73,0.11);
    &::after{
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      border-radius: 100%;
      background: url('./pmImg/icon_rit.png') center center no-repeat;
      background-size: 10px 10px;
    }
  }
  .swiper-ui-button-prev, .swiper-ui-scroll-button-prev{
    position: relative;
    cursor: pointer;
    width: 31px;
    height: 31px;
    border-radius: 31px;
    background: #FFFFFF;
    box-shadow: 0 0 8px 0 rgba(22,37,73,0.11);
    &::after{
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      border-radius: 100%;
      background: url('./pmImg/icon_lt.png') center center no-repeat;
      background-size: 10px 10px;
    }
  }
  .swiper-ui-disabled-class{
    &::after{
      opacity: 0.3;
    }
  }
}
.uiScrollSwiper{
  .swiper-pagination-bullet{
    width: 8px !important;
    height: 8px !important;
  }
}
@media screen and (min-width: 1480px) {
  .pmHomeModular .srcBox .row .col .blc div{
    margin-bottom:4px !important;
     width: 125px !important;
  }  
}  
@media screen and (min-width: 1580px) {
  .pmHomeModular .srcBox .row .col .blc div{
    margin-bottom:6px !important;
    width: 135px !important;
  }  
} 
@media screen and (min-width: 1660px) {
  .pmHomeModular .srcBox .row .col .blc div{
    margin-bottom:8px !important;
    width: 140px !important;
  }  
} 
@media screen and (min-width: 1760px) {
  .pmHomeModular .srcBox .row .col .blc div{
    margin-bottom:11px !important;
    width: 155px !important;
  }  
}  
</style>
